import { useState } from "react";
import StatsWidgets from "@rio-cloud/rio-uikit/StatsWidgets";

import MaintenanceBigNumbers from "./maintenanceBigNumbers";
import RioPlanBigNumbers from "./rioPlanBigNumbers";
import VolksTotalPlanBigNumbers from "./volksTotalPlanBigNumbers";
import { IAssetSummary } from "../../api/fetchMaintenance";
import { Asset } from "../../models/asset";

import "./styles.scss";

interface IBigNumbersProps {
  allAssets: Asset[];
  assetIds: string[];
  setAssetIds: (e: string[] | undefined) => void;
  assets: IAssetSummary[];
  disabled?: boolean;
  bigTableLoading?: boolean;
  persona: 'MANAGER' | 'TOWER' | 'CONSULTANT' | 'PARTNERSHIP';
  setAvailableToScheduleAssetIds?: (e: string[]) => void;
}

const BigNumbers = ({ allAssets, assetIds, setAssetIds, assets, disabled, bigTableLoading, persona, setAvailableToScheduleAssetIds }: IBigNumbersProps) => {
  const [filter, setFilter] = useState<string>("");

  // Rio big numbers 
  const [withRioPlanAssetIds, setWithRioPlanAssetIds] = useState<string[]>([]);
  const [withoutRioPlanAssetIds, setWithoutRioPlanAssetIds] = useState<string[]>([]);
  const [byRioPlan, setByRioPlan] = useState<{ [key: string]: string[] }>({});

  // Maintenance big numbers
  const [toScheduleAssetIds, setToScheduleAssetIds] = useState<string[]>([]);
  const [delayedMaintenanceAssetIds, setDelayedMaintenanceAssetIds] = useState<string[]>([]);
  const [scheduledAssetIds, setScheduledAssetIds] = useState<string[]>([]);
  const [underMaintenanceAssetIds, setUnderMaintenanceAssetIds] = useState<string[]>([]);
  
  return (
    <>
      <StatsWidgets className="big-numbers">

        <MaintenanceBigNumbers
          assets={assets}
          setAssetIds={setAssetIds}
          assetIds={assetIds}
          filter={filter}
          setFilter={setFilter}
          toScheduleAssetIds={toScheduleAssetIds}
          setToScheduleAssetIds={(e: string[]) => {
            setToScheduleAssetIds(e);
            setAvailableToScheduleAssetIds?.(e);
          }}
          delayedMaintenanceAssetIds={delayedMaintenanceAssetIds}
          setDelayedMaintenanceAssetIds={setDelayedMaintenanceAssetIds}
          scheduledAssetIds={scheduledAssetIds}
          setScheduledAssetIds={setScheduledAssetIds}
          underMaintenanceAssetIds={underMaintenanceAssetIds}
          setUnderMaintenanceAssetIds={setUnderMaintenanceAssetIds}
          disabled={disabled}
          bigTableLoading={bigTableLoading}
          allAssets={allAssets}
          persona={persona}
        />

        <RioPlanBigNumbers
          assets={assets}
          assetIds={assetIds}
          setAssetIds={setAssetIds}
          filter={filter}
          setFilter={setFilter}
          withRioPlanAssetIds={withRioPlanAssetIds}
          setWithRioPlanAssetIds={setWithRioPlanAssetIds}
          withoutRioPlanAssetIds={withoutRioPlanAssetIds}
          setWithoutRioPlanAssetIds={setWithoutRioPlanAssetIds}
          byRioPlan={byRioPlan}
          setByRioPlan={setByRioPlan}
          disabled={disabled}
          bigTableLoading={bigTableLoading}
          allAssets={allAssets}
        />

        <VolksTotalPlanBigNumbers
          setAssetIds={setAssetIds}
          assets={assets}
          assetIds={assetIds}
          filter={filter}
          setFilter={setFilter}
          disabled={disabled}
          bigTableLoading={bigTableLoading}
          allAssets={allAssets}
        />

      </StatsWidgets>
    </>
  );
};

export default BigNumbers;
